import React from "react";
import { MessageIcon } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { Agent } from "@/components/molecules/cta-button/cta-buttons";
import styles from "@/components/molecules/question-detail-section/question-detail-section.module.css";
import { showMessenger } from "@/utils/cxone.utils";

import { getSupportDescription } from "./description-section.utils";
import { useCoverTypeContext } from "../../provider/cover-type.provider";

function CoverForDescriptionSection() {
  const { selectedAnswer, magnoliaData } = useCoverTypeContext();
  const { chatButtonLabel } = magnoliaData.overlayArea[0];
  const { wizard, current } = useWizard();
  const { productSpecialFeatures } = wizard;
  const showNewChatButton = productSpecialFeatures?.showNewChatButton;
  const showDefaultStaysure =
    current.uiElementControls?.showdefaultDescriptionSection;
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;

  return (
    <div className="flex flex-col-reverse md:flex-col h-full">
      <div className="flex-1 flex items-center justify-center">
        <section
          className={`${
            selectedAnswer !== 0 ||
            current.uiElementControls?.showdefaultDescriptionSection
              ? "px-spacing-l md:px-spacing-xxxl mt-spacing-m md:mt-0"
              : ""
          } `}
        >
          <div
            className={`${
              selectedAnswer !== 0 ||
              current.uiElementControls?.showdefaultDescriptionSection
                ? showNewButtonsLayout
                  ? "lg:max-w-[373px] md:max-w-[560px]"
                  : "lg:max-w-[325px] md:max-w-[432px]"
                : ""
            } mx-auto`}
          >
            {getSupportDescription(selectedAnswer, showDefaultStaysure)}
          </div>
        </section>
      </div>

      {showNewChatButton && (
        <div
          className={`w-full flex justify-center md:mt-spacing-m mt-auto ${styles.agentButton}`}
        >
          <Agent
            label={chatButtonLabel ?? "Not sure? Chat with us"}
            hierarchy="secondary"
            className="w-[275px] md:w-[300px] h-[56px] px-spacing-l py-spacing-s [&:hover_path]:stroke-interactive-secondary-default"
            rightIcon={
              <span style={{ marginLeft: "4px" }}>
                <MessageIcon stroke="white" fill="white" />
              </span>
            }
            isRightIcon
            semanticColor="Dark Background"
            onClick={() => {
              if (typeof window !== "undefined") {
                showMessenger();
              }
            }}
          />
        </div>
      )}
    </div>
  );
}

export default CoverForDescriptionSection;
